import TextInput from './inputs/TextInput.vue'
import SelectInput from './inputs/SelectInput'
import TagInput from './inputs/TagInput.vue'
import Modal from './modals/Modal'

export default [
    TextInput, SelectInput, Modal, TagInput
]